import { BlurOn } from "@mui/icons-material";
import React, { useContext } from "react";
import { PersonnelType } from "../../../../types/GlobalType";
import { personnelContext } from "../../../../context/AppContext";

const ParcoursInfo = () => {
  const personnelData: PersonnelType = useContext(personnelContext);

  return (
    <div className="tuteur_info">
      <h4 className="title_section">Adresse résidentielle</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>{personnelData.avenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{personnelData.quartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{personnelData.commune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{personnelData.ville?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Téléphone:</td>
          <td>{personnelData.telephone?.toUpperCase()}</td>
        </tr>
      </table>
      {/* 
      <h4 className="title_section_2">Résidence</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>De la Conference</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>Kyeshero</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>Goma</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>Goma</td>
        </tr>
      </table> */}
    </div>
  );
};

export default ParcoursInfo;
